/**
 * Created by rathompson on 8/2/23
 * File: IpActionsRenderer.tsx
 * Project: cloud-mgmt-modules ©
 * ©
 */


import type { VFC } from 'react'
import type { Row } from 'react-table'
import type { TrustedIpTableRow } from '../TrustedIpTable'
import { useCallback, useContext, useMemo } from 'react'
import GlobalContext from '../../../../common/context/GlobalContext'
import { DeleteIcon } from '@panwds/icons'
import TooltipButton from '../../../../common/components/tooltipButton/TooltipButton'
import { LABEL_HAS_UNSAVED_CHANGES, LABEL_INHERITED_IP } from '../../../constants/LabelConstants'
import { IP_ALLOW_PERMISSION_SET } from '../../../../common/constants/GlobalConstants'
import ReadOnlyButton from '../../../../common/components/noAccess/ReadOnlyButton'

const IpActionsRenderer: VFC<{
  row: Row<TrustedIpTableRow>,
  onDelete: Function,
  hasUnsavedChanges: boolean
}> = ({ row, onDelete, hasUnsavedChanges }) => {

  const { treeReducer } = useContext(GlobalContext)
  const { selectedTreeNode } = treeReducer

  const { original } = row
  const { ip, inherited_from } = original

  const isInherited = useMemo(() => inherited_from && inherited_from !== selectedTreeNode?.id, [selectedTreeNode, inherited_from])

  const onDeleteClick = useCallback(() => {
    onDelete(original)
  }, [onDelete, original])

  const deleteDisabled = useMemo(() => isInherited || (hasUnsavedChanges && original.id.includes('old')), [hasUnsavedChanges, isInherited, original.id])

  const tooltipLabel = useMemo(() => {
    if (isInherited) {
      return LABEL_INHERITED_IP
    }
    if (hasUnsavedChanges) {
      return LABEL_HAS_UNSAVED_CHANGES
    }
    return ''
  }, [hasUnsavedChanges, isInherited])

  return ip === 'Any' ? (
    <></>
  ) :
    (deleteDisabled) ? (
      <TooltipButton
        label={tooltipLabel}
        disabled
        buttonProps = {{
          'aria-label': 'role-trash',
          appearance: 'clear',
          style: { background: 'transparent' },
          icon: (
            <DeleteIcon size='sm' className='cm-text-gray-400' />
          )
        }}/>
    ) : (
      <ReadOnlyButton
        tsg_id={selectedTreeNode?.id}
        permissionSet={IP_ALLOW_PERMISSION_SET}
        aria-label='ip-trash'
        appearance='clear'
        style={{ background: 'transparent' }}
        icon={(
          <DeleteIcon size='sm' className='cm-text-gray-400' />
        )}
        onClick={onDeleteClick}
      />
    )
}

export default IpActionsRenderer
